module.exports = __webpack_public_path__ + "img/section4.a4ac9834.jpg";